<template>
    <vx-card :title="'Pedido Libros Hijos Docentes# '+pedido.id_pedido" class="mt-3">
        <div v-if="menu == 0">
            <div class="flex">
                <vs-button color="success" v-if="usuario.id_group == 11 || usuario.id_group == 22 ||  usuario.id_group == 23 || userRoot == true" @click="guardarValorPedidoLibrosObsequios()" icon="save" type="filled">Crear pedido Libros Hijos Docentes/Obsequios </vs-button>
            </div>
            <div v-if="exportTodo">
                <!-- <vs-button color="success" v-if="usuario.id_group == 22 ||  usuario.id_group == 23" @click="librosObsequios=sendPedido;mostrarDetalle(sendPedido)" type="filled">Detalle aprobados</vs-button> -->
                <!-- <vs-button color="success" v-if="usuario.id_group == 22 ||  usuario.id_group == 23" @click="librosObsequios=sendPedido;realizarDetalle(1)" type="filled">Detalle aprobados</vs-button> -->
                <!-- <vs-button color="success" v-if="(usuario.id_group == 22 ||  usuario.id_group == 23 || usuario.id_group == 1) && datosAprobados > 0" @click="librosObsequios=sendPedido;AbrirDatosDetalle()" type="filled">Detalle aprobados</vs-button> -->
            </div>
            <vs-table max-items="10" stripe search pagination :data="arregloLibrosObsequios">
                <template slot="header">
                    <vs-chip color="primary">Cantidad: {{ arregloLibrosObsequios.length }}</vs-chip>
                    <!-- <vs-radio class="ml-2" v-if="usuario.id_group == 22 ||  usuario.id_group == 23 || userRoot == true " v-model="seleccion"
                                    vs-value="gerencia" @input="getLibrosObsequios(5);e">Autorizado por Gerencia</vs-radio> -->
                    <vs-radio class="ml-2" v-if="usuario.id_group == 22 ||  usuario.id_group == 23 || userRoot == true " v-model="seleccion" vs-value="gerencia1" @change="getLibrosObsequios(6);">Por Aprobar</vs-radio>
                    <vs-radio class="ml-2" v-if="usuario.id_group == 22 ||  usuario.id_group == 23 || userRoot == true " v-model="seleccion" vs-value="gerencia2" @change="getLibrosObsequios(7);">Aprobados</vs-radio>
                    <vs-radio class="ml-2" v-if="usuario.id_group == 22 ||  usuario.id_group == 23 || userRoot == true " v-model="seleccion" vs-value="gerencia3" @change="getLibrosObsequios(8);">Rechazados</vs-radio>
                    <vs-radio class="ml-2" v-if="usuario.id_group == 22 ||  usuario.id_group == 23 || userRoot == true " v-model="seleccion" vs-value="todos" @change="getLibrosObsequios(0);">Todos</vs-radio>
                </template>
                <template slot="thead">
                    <vs-th>Pedido ID#</vs-th>
                    <vs-th>Detalle</vs-th>
                    <vs-th>Observaciones</vs-th>
                    <vs-th>Estado</vs-th>
                    <vs-th>Acciones</vs-th>
                </template>
                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td width="15%">
                            #{{data[indextr].id}}<br>
                            <small>{{ tr.contrato_generado }}</small>
                            <br>
                            <small>{{ tr.nombreInstitucion }}</small>
                        </vs-td>
                        <vs-td width="20%">
                            <small><b>Descuento:</b></small>
                            <p>{{data[indextr].porcentaje_descuento}}%</p>
                            <small><b>Total unidades:</b></small>
                            <p>{{data[indextr].total_unidades}}</p>
                            <br>
                            <small><b>Fecha Creación:</b></small>
                            <p>{{data[indextr].created_at}}</p>
                            <small><b>Usuario Creador:</b></small>
                            <p>{{data[indextr].creador}}</p>
                        </vs-td>
                        <vs-td height="40%" width="40%">
                            <div class="overflow-y-auto h-24">
                                <div v-if="tr.usuario_aprobacion && tr.grupo_aprobador==22 || tr.grupo_aprobador==1 || tr.grupo_aprobador==23 ">
                                    <span color="danger"><b>Aprobado por:</b> {{tr.usuario_aprobacion}}</span><br>
                                </div>
                                <div v-if="tr.usuario_aprobacion && tr.grupo_aprobador==25">
                                    <span color="danger"><b>Autorizado por:</b> {{tr.usuario_aprobacion}}</span><br>
                                </div>
                                <div v-if="(tr.observacion_asesor && tr.observacion_asesor !== null && tr.observacion_asesor !== 'null')&&(tr.grupo_creador==11)">
                                    <b>Asesor:</b> {{ tr.observacion_asesor }}
                                </div>
                                <div v-if="tr.estado_libros_obsequios == 5 || tr.observacion_facturador" class="mt-5">
                                    <b>Facturador:</b> {{ tr.observacion_facturador }}
                                </div>
                            </div>
                        </vs-td>
                        <vs-td width="20%">
                            <div v-if="tr.estado_libros_obsequios == 4 && tr.porcentaje_descuento >= 100" class="my-2" style="background-color:#e93c3c;padding:4px;border-radius:5px;">
                                <span style="color:white;">Pendiente aprobación de Facturador Admin</span>
                            </div>
                            <div v-if="tr.estado_libros_obsequios == 0">
                                <vs-chip color="primary" transparent>
                                    <vs-avatar color="#2478c1" icon-pack="feather" icon="icon-file-plus" />
                                    <span>Abierto</span>
                                </vs-chip>
                            </div>
                            <div v-if="tr.estado_libros_obsequios == 4">
                                <vs-chip color="dark" transparent>
                                    <vs-avatar icon-pack="feather" icon="icon-user-check" />
                                    <span>Aprobado por Gerencia</span>
                                </vs-chip>
                            </div>
                            <div v-if="tr.estado_libros_obsequios == 5">
                                <vs-chip color="success" transparent>
                                    <vs-avatar color="#24c1a0" icon-pack="feather" icon="icon-check-circle" />
                                    <span>Pedido Aprobado </span>
                                </vs-chip>
                            </div>
                            <div v-if="tr.estado_libros_obsequios == 1">
                                <vs-chip color="danger" transparent>
                                    <vs-avatar color="#c12424" icon-pack="feather" icon="icon-minus-square" />
                                    <span>Anulado</span>
                                </vs-chip>
                            </div>
                            <div v-if="tr.estado_libros_obsequios == 2">
                                <vs-chip color="danger" transparent>
                                    <vs-avatar color="#c12424" icon-pack="feather" icon="icon-slash" />
                                    <span>Rechazado</span>
                                </vs-chip>
                            </div>
                            <div v-if="tr.estado_libros_obsequios == 6">
                                <vs-chip color="danger" transparent>Aprobado con Pendiente</vs-chip>
                            </div>
                            <div v-if="tr.estado_libros_obsequios == 7">
                                <vs-chip color="rgb(62, 201, 214)" transparent>Preaprobado por Facturador</vs-chip>
                            </div>
                            <div v-if="tr.estado_libros_obsequios == 8 && ( usuario.id_group == 22 ||  usuario.id_group == 23 ||  usuario.id_group == 25 || userRoot == true )">
                                <vs-chip color="dark" transparent>
                                    <vs-avatar color="#242121" icon-pack="feather" icon="icon-gift" />
                                    <span>Pedido Obsequio</span>
                                </vs-chip>
                            </div>
                            <div v-if="tr.estado_libros_obsequios == 3 && usuario.id_group == 11">
                                <vs-chip color="warning" transparent>
                                    <vs-avatar color="#c1a424" icon-pack="feather" icon="icon-send" />
                                    <span>Enviado</span>
                                </vs-chip>
                            </div>
                            <div v-if="tr.estado_libros_obsequios == 3 && ( usuario.id_group == 22 ||  usuario.id_group == 23 ||  usuario.id_group == 25 || userRoot == true )">
                                <vs-chip color="warning" transparent>
                                    <vs-avatar color="#c18f24" icon-pack="feather" icon="icon-bar-chart-2" />
                                    <span>Por Aprobar</span>
                                </vs-chip>
                            </div>
                            <div v-if="tr.estado_libros_obsequios == 8 && usuario.id_group == 11">
                                <vs-chip color="dark" transparent>
                                    <vs-avatar color="#242121" icon-pack="feather" icon="icon-gift" />
                                    <span>Enviado como Obsequio</span>
                                </vs-chip>
                            </div>
    
                        </vs-td>
                        <vs-td width="30%">
                            <vs-dropdown vs-custom-content vs-trigger-click>
                                <vs-button class="a-icons" href.prevent icon="more_vert" type="border"></vs-button>
                                <vs-dropdown-menu style="width: 250px;" class="cursor">
                                    <div>
                                        <vs-dropdown-item v-if="tr.estado_libros_obsequios == 3 && ( usuario.id_group == 22 )">
                                            <!--ACEPTAR PEDIDO-->
                                            <vs-button class="w-full" color="success" @click="librosObsequios=tr;openConfirmLibrosObsequios(tr);acta.empresa='';mostrarMensajeVariacion=false;acta.ci='';" icon-pack="feather" icon="icon-check" type="line"> Aceptar pedido Libros
                                                Obsequios </vs-button>
                                        </vs-dropdown-item>
                                        <vs-dropdown-item v-if="(tr.estado_libros_obsequios == 4 || tr.estado_libros_obsequios == 3 || tr.estado_libros_obsequios == 6 || tr.estado_libros_obsequios == 7) && ( usuario.id_group == 23 || userRoot == true )">
                                            <!--GENERAR ACTA-->
                                            <vs-button class="w-full" color="#910606" @click="DatosAprobar=tr;verificarIniciales(tr);acta.empresa='';mostrarMensajeVariacion=false;acta.ci='';" icon-pack="feather" icon="icon-file-plus" type="line"> {{ tr.estado_libros_obsequios == 6 ? 'Aceptar pendiente Libros Hijos Docentes' : 'Aceptar pedido Libros Hijos Docentes' }}</vs-button>
                                        </vs-dropdown-item>
                                        <vs-dropdown-item v-if="( tr.estado_libros_obsequios == 8) && ( usuario.id_group == 23 || userRoot == true || usuario.id_group == 22 )">
                                            <!--GENERAR ACTA obsequios-->
                                            <vs-button class="w-full" color="#284f28" @click="DatosAprobar=tr;verificarIniciales(tr);acta.empresa='';mostrarMensajeVariacion=false;acta.ci='';" icon-pack="feather" icon="icon-file-plus" type="line"> {{ tr.estado_libros_obsequios == 6 ? 'Aceptar pendiente Libros Obsequios' : 'Aceptar pedido Libros Obsequios' }}</vs-button>
                                        </vs-dropdown-item>
                                        <vs-dropdown-item v-if="(tr.estado_libros_obsequios == 8) && (usuario.id_group == 23 ||  usuario.id_group == 25 || userRoot == true )">
                                            <!--RECHAZAR PEDIDO obsequios-->
                                            <vs-button color="#b54414" type="line" icon-pack="feather" icon="icon-x" @click="librosObsequios=tr;VerificacionRechazoPedido(tr)" class="w-full text-normal p-2">Rechazar pedido Libros Obsequios</vs-button>
                                        </vs-dropdown-item>
                                        <vs-dropdown-item v-if="tr.estado_libros_obsequios == 8 && (usuario.id_group == 11 || ( usuario.id_group == 22 ||  usuario.id_group == 23 || userRoot == true ))">
                                            <!--MOSTRAR /REGISTRAR LIBROS-->
                                            <vs-button color="success" type="line" icon-pack="feather" icon="icon-book" class="w-full" @click="vacilarEmits();pedidoLibrosObsequios.observacion_asesor='';librosObsequios=tr;menu = 3;pedidoLibrosObsequios.observacion_asesor=tr.observacion_asesor">
                                                {{ usuario.id_group == '11' ? 'Registrar': usuario.id_group == '23' || usuario.id_group == '22' || userRoot == true ? 'Modificar': 'Registrar'}} Libros Obsequios</vs-button>
                                        </vs-dropdown-item>
                                        <vs-dropdown-item v-if="(tr.estado_libros_obsequios == 3 || tr.estado_libros_obsequios == 7) && (usuario.id_group == 23 ||  usuario.id_group == 25 || userRoot == true )">
                                            <!--RECHAZAR PEDIDO-->
                                            <vs-button color="warning" type="line" icon-pack="feather" icon="icon-x" @click="librosObsequios=tr;VerificacionRechazoPedido(tr)" class="w-full text-normal p-2">Rechazar pedido Libros Hijos Docentes</vs-button>
                                        </vs-dropdown-item>
                                        <vs-dropdown-item v-if="(tr.estado_libros_obsequios != 5 || tr.estado_libros_obsequios != 6 ) && tr.estado_libros_obsequios == 0 || tr.estado_libros_obsequios == 3 && (usuario.id_group == 11 || ( usuario.id_group == 22 ||  usuario.id_group == 23 || userRoot == true ))">
                                            <!--MOSTRAR /REGISTRAR LIBROS-->
                                            <vs-button color="success" type="line" icon-pack="feather" icon="icon-book" class="w-full" @click="vacilarEmits();pedidoLibrosObsequios.observacion_asesor='';librosObsequios=tr;menu = 3;pedidoLibrosObsequios.observacion_asesor=tr.observacion_asesor">
                                                {{ usuario.id_group == '11' ? 'Registrar': usuario.id_group == '23' || usuario.id_group == '22' || userRoot == true ? 'Modificar Pedido': 'Registrar'}} Libros Hijos Docentes</vs-button>
                                        </vs-dropdown-item>
                                        <vs-dropdown-item v-if="(tr.estado_libros_obsequios == 5 || tr.estado_libros_obsequios == 4) && (usuario.id_group == 23|| userRoot == true)">
                                            <!--ANULAR LIBROS-->
                                            <vs-button color="dark" type="line" icon-pack="feather" icon="icon-alert-triangle" class="w-full" @click="librosObsequios=tr;datosAnularLibrosObsequios=[];abrirAnularLibrosObsequios(tr,1)">Anular pedido Libros Obsequios</vs-button>
                                        </vs-dropdown-item>
                                        <vs-dropdown-item v-if="tr.estado_libros_obsequios == 8">
                                            <!--RESUMEN LIBROS Obsequios-->
                                            <vs-button color="primary" type="line" icon-pack="feather" icon="icon-bookmark" class="w-full" @click="librosObsequios=tr;mostrarResumen(tr)">Resumen Libros Obsequios</vs-button>
                                        </vs-dropdown-item>
                                        <vs-dropdown-item v-if="tr.estado_libros_obsequios !== 8">
                                            <!--RESUMEN LIBROS Hijos Docentes-->
                                            <vs-button color="primary" type="line" icon-pack="feather" icon="icon-bookmark" class="w-full" @click="librosObsequios=tr;mostrarResumen(tr)">Resumen Libros Hijos Docentes</vs-button>
                                        </vs-dropdown-item>
    
                                        <!-- <vs-dropdown-item v-if="tr.estado_libros_obsequios == 0">
                                                        <vs-button color="warning" type="line" icon-pack="feather" icon="send"
                                                            class="w-full" @click="librosObsequios=tr;menu = 4">Mandar Pedido Libros
                                                            Obsequios</vs-button>
                                                    </vs-dropdown-item> -->
                                        <vs-dropdown-item v-if="tr.estado_libros_obsequios == 5 || tr.estado_libros_obsequios == 6 || tr.estado_libros_obsequios == 1">
                                            <!--REPORTE PDF-->
                                            <vs-button color="dark" type="line" icon-pack="feather" icon="icon-eye" class="w-full" @click="librosObsequios=tr;actasLibrosObsequios()">Ver Actas </vs-button>
                                        </vs-dropdown-item>
                                        <vs-dropdown-item v-if="tr.estado_libros_obsequios === 0 || tr.estado_libros_obsequios === 2">
                                            <!--ELIMINAR-->
                                            <vs-button color="danger" icon-pack="feather" icon="icon-trash" type="line" class="w-full" @click="librosObsequios=tr;menu = 1" v-if="(usuario.id_group == 11 || userRoot == true ) && (tr.estado_libros_obsequios === 0 || tr.estado_libros_obsequios === 2)">Eliminar</vs-button>
                                        </vs-dropdown-item>
                                        <!--MODIFICAR PEDIDO Y ACTA-->
                                        <!-- <vs-dropdown-item v-if="tr.estado_libros_obsequios == 5">
                                                <vs-button color="danger" icon-pack="feather" icon="icon-edit" type="line" class="w-full" @click="librosObsequios=tr;abrirModificacionPedidoActa(tr);" v-if="(userRoot == true ) && (tr.estado_libros_obsequios == 5)">Cambio detalles acta/pedido</vs-button>
                                            </vs-dropdown-item> -->
                                    </div>
                                </vs-dropdown-menu>
                            </vs-dropdown>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </div>
        <div v-if="menu == 1">
            <p class="text-danger font-bold text-center">Estas seguro de querer eliminar el pedido Libros Hijos Docentes?</p>
            <div class="flex justify-center">
                <p class="mt-1"></p>
                <vs-button color="danger" @click="eliminarLibrosObsequios()" type="border" icon="delete">Si deseo,
                    eliminar</vs-button>
                <vs-button color="primary" @click="menu = 0;getLibrosObsequios(0)" class="ml-3" type="filled" icon="close">Salir, Sin Enviar</vs-button>
            </div>
        </div>
        <!--RESUMEN LIBROS-->
        <div v-if="menu == 2">
            <vs-button color="primary" type="border" @click="menu = 0;">← Regresar</vs-button>
            <resumenLibrosObsequiosVue :librosObsequios="librosObsequios" />
        </div>
        <!--REGISTRAR LIBROS-->
        <div v-if="menu == 3">
            <vs-button v-if="itemsDelPedido==0" color="primary" type="border" @click="menu = 0;getLibrosObsequios(0)">← Regresar</vs-button>
            <screenPedidoLibrosObsequiosVue @enviar_cantidad="recibirCantidad" :librosObsequios="librosObsequios" class="mt-2" :sendPedido="sendPedido" :userRoot="Boolean(userRoot)" />
            <br><br>
            <!-- <div v-if="mostrarMensajeEnviado"> -->
            <div v-if="(mostrarMensajeEnviado && itemsDelPedido > 0) || librosObsequios.estado_libros_obsequios == 3">
                <vs-alert class="mb-3" color="danger" icon="new_releases">
                    <span v-if="( usuario.id_group == 22 ||  usuario.id_group == 23 || userRoot == true )" class="font-bold ">Para guardar la información, no olvides verificar que la información sea precisa.</span>
                    <span v-else class="font-bold ">Para enviar la información, no olvides verificar que la información sea precisa.</span>
                </vs-alert>
                <!-- <p class="text-danger font-bold text-center">Para enviar la información, no olvides verificar que la información sea precisa.</p><br> -->
                <div v-if="usuario.id_group == 11" class="flex justify-center">
                    <vs-textarea label="Observación del Pedido Libros Hijos Docentes:" placeholder="Escribe tu observación antes de enviar o actulizar tu pedido." class="w-full" v-model="pedidoLibrosObsequios.observacion_asesor" />
                </div>
                <div class="flex justify-center">
                    <p class="mt-1"></p>
                    <vs-button color="success" @click="CambiarEstadoLibrosObsequios(librosObsequios,3)" icon="send">
                        <span v-if="estadoPedidoLibrosHijosDocentes === 3 || librosObsequios.estado_libros_obsequios == 3">Actualizar envío a Facturación</span>
                        <span v-else-if="( usuario.id_group == 22 ||  usuario.id_group == 23 || userRoot == true )">Guardar</span>
                        <span v-else>Enviar a Facturación</span>
                    </vs-button>
                    <vs-button color="primary" @click="menu = 0;getLibrosObsequios(0)" class="ml-3" type="filled" icon="close">
                        <span v-if="( usuario.id_group == 22 ||  usuario.id_group == 23 || userRoot == true )">Salir sin Guardar</span>
                        <span v-else>Salir, Sin Enviar</span>
                    </vs-button>
                </div>
            </div>
        </div>
        <!-- <div v-if="menu == 4">
                        <p class="text-danger font-bold text-center">¿Estás seguro de querer proceder con el envío de los libros
                            como obsequios N°{{librosObsequios.id}}?</p><br>
                        <p class="text-danger font-bold text-center">No olvides verificar que la información sea precisa antes de
                            enviarla.</p><br>
                        <div class="flex justify-center">
                            <vs-textarea label="Observación del Pedido Libros Obsequios:"
                                placeholder="Escribe tu observación antes de enviar." class="w-full"
                                v-model="pedidoLibrosObsequios.observacion_asesor" />
                        </div>
                        <div class="flex justify-center">
                            <p class="mt-1"></p>
                            <vs-button color="success" @click="CambiarEstadoLibrosObsequios(librosObsequios,3)" icon="send">Enviar a Aprobación</vs-button>
                            <vs-button color="primary" @click="menu = 0;getLibrosObsequios(0)" class="ml-3" type="filled"
                                icon="close">Cancelar</vs-button>
                        </div>
                    </div> -->
        <!--DETAllE LIBROS-->
        <div v-if="menu == 5">
            <vs-button color="primary" type="border" @click="menu = 0;">← Regresar</vs-button>
            <detalleAprobadorLibrosObsequios :librosObsequios="librosObsequios" />
        </div>
        <div v-if="menu == 6">
            <vs-button color="primary" type="border" @click="menu = 0;">← Regresar</vs-button>
            <actasLibrosObsequios :librosObsequios="librosObsequios" />
        </div>
        <!--REPORTE-->
        <div v-if="popupReportePedidoLibroObsequio">
            <exportLibrosObsequiosVueVue style="display:none;" :tipoFile="tipoFile" :librosObsequios="librosObsequios" @change="changeHandle" />
        </div>
        <div v-if="popupDetallePedidoLibroObsequio">
            <exportDetalleLibrosObsequios style="display:none;" :porcentaje_detalle="porcentaje_detalle" :observacion_detalle="observacion_detalle" :tipoFile="tipoFile" :librosObsequios="librosObsequios" @change="changeHandle" />
        </div>
        <!--MODALES-->
        <vs-popup class="holamundo" title="Cargando" :active.sync="popupCarga">
            <p class="text-warning text-3xl bg-dark"><i class="fa-solid fa-cloud"></i> <b class="ml-2">Espere mientras
                    se descarga el archivo</b></p>
            <img class="mt-2" style="margin-left: 35px;" src="https://cdn-icons-png.flaticon.com/512/4578/4578845.png" />
        </vs-popup>
        <!--DATOS DETALLE-->
        <vs-popup class="holamundo" title="Observacion Detalle" :active.sync="popupDatosDetalle">
            <vs-row>
                <vs-col vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
                    <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                        <vs-col vs-justify="center" vs-align="center" vs-w="10">
                            <vs-textarea label="Observación:" placeholder="Escribe..." class="w-full" v-model="observacion_detalle" />
                        </vs-col>
                    </vs-row>
                </vs-col>
            </vs-row>
            <br>
            <vs-row>
                <vs-button @click="guardarDatosDetalle();" type="relief" color="success">Guardar</vs-button>&emsp;
            </vs-row>
        </vs-popup>
        <!-- GENERAR ACTA -->
        <vs-popup fullscreen :title="acta.estado_libros_obsequios !== 8 ? `Aprobación del Pedido Libros Hijos Docentes n° ${acta.id_pedido_librosObsequios}`: `Aprobación del Pedido Libros Obsequios n° ${acta.id_pedido_librosObsequios}`" :active.sync="popupActa">
            <vs-row>
                <!-- {{acta}} -->
                <vs-row>
                    <vs-col v-if="acta.empresa" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12" style="text-align: center;"><b style="font-size: 15px">Acta n° {{ acta.codigoPedidoLibrosActa }}</b></vs-col>
                    <vs-col vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
                        <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                            <vs-col vs-justify="center" vs-align="center" vs-w="10">
                                <font style="font-size: 11.5px">&nbsp;Empresa:</font><br>
                                <v-select :options="listaEmpresas" :reduce="listaEmpresas => listaEmpresas.id" label="nombre" class="w-full h-100" placeholder="--Seleccione--" v-model="acta.empresa" @input="acta.codigoPedidoLibrosActa= '';getCodigoActa(acta.empresa);getLibrosActa(DatosAprobar.id);" />
                            </vs-col>
                        </vs-row>
                    </vs-col>
                </vs-row>
                <vs-row v-if="acta.empresa">
                    <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
                        <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
                                <vs-input label="Institución Beneficiada:" class="w-full" v-model="acta.institucion" readonly />
                            </vs-col>
                        </vs-row>
                    </vs-col>
                    <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
                        <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
                                <vs-input label="Responsable:" class="w-full" v-model="acta.responsable" readonly />
                            </vs-col>
                        </vs-row>
                    </vs-col>
                    <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
                        <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
                                <vs-input label="Dirección:" class="w-full" v-model="acta.direccion" readonly />
                            </vs-col>
                        </vs-row>
                    </vs-col>
                    <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
                        <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
                                <vs-input label="Teléfono:" class="w-full" v-model="acta.telefono" readonly />
                            </vs-col>
                        </vs-row>
                    </vs-col>
                    <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
                        <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                            <vs-col vs-justify="center" vs-align="center" vs-w="10">
                                <font style="font-size: 11.5px">&nbsp;Cliente:</font><br>
                                <v-select :options="arregloBeneficiario" :reduce="arregloBeneficiario => arregloBeneficiario.id_usuario" label="fullLabel" class="w-full h-100" placeholder="--Seleccione--" v-model="acta.beneficiario" @input="mostrarMensajeVariacion=false;ponerCedulaCliente();evaluarCedulaCliente();" />
                            </vs-col>
                        </vs-row>
                    </vs-col>
                    <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
                        <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
                                <vs-input label="CI:" class="w-full" v-model="acta.ci" readonly />
                            </vs-col>
                        </vs-row>
                    </vs-col>
                    <vs-col vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
                        <span v-if="mostrarMensajeVariacion">
                            <vs-alert color="danger" icon-pack="feather" icon="icon-info">
                                <span>Se ha creado una proforma con un número de <b>CI/RUC diferente</b>, verifica antes de continuar.</span>
                                <span v-if="arregloOtherUsers.length>0">
                                    CI/RUC utilizados: <span v-for="(cliente, index) in arregloOtherUsers" :key="index"> <b class="px-2">{{ cliente.ruc_cliente }}</b></span>
                                </span>
                            </vs-alert>
                        </span>
                    </vs-col>
                    <vs-col v-if="acta.empresa == 1?arregloLibros.some(tr => tr.p_libros_cantidad_pendiente > tr.pro_deposito):acta.empresa == 3?arregloLibros.some(tr => tr.p_libros_cantidad_pendiente > tr.pro_depositoCalmed):false" vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
                        <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
                                <b for="checkbox">Permitir stock</b>
                                <vs-switch class="m-5" v-model="permitirStock" />
                            </vs-col>
                        </vs-row>
                    </vs-col>
                </vs-row>
            </vs-row>
            <vs-row v-if="acta.empresa">
                <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                    <vs-divider>Detalle del pedido Libros Hijos Docentes</vs-divider>
                    <vs-table max-items="20" :data="arregloLibros">
                        <template slot="header">
                            <span>Cantidad: {{arregloLibros.length}}</span>
                            <span>Descuento: {{porcentaje_descuento}}%</span>
                        </template>
                        <template slot="thead">
                            <vs-th>Libro</vs-th>
                            <vs-th>Cant. unidades</vs-th>
                            <vs-th><span v-if="acta.empresa === 1 ">Stock disponible Notas (Prolipa)</span><span v-else>Stock disponible Notas (Calmed)</span></vs-th>
                        </template>
                        <template slot-scope="{data}">
                            <vs-tr :state="tr.p_libros_cantidad_pendiente > getStockDepositoValue(tr)  ? 'danger':null" v-for="(tr, index) in data" :key="index">
                                <vs-td>
                                    <span v-if="tr.id_serie === 19">
                                        <b>{{ tr.pro_nombre }}</b><br>
                                        <b>Descripción Combo: <br>{{ tr.descripcionlibro }}</b>
                                    </span>
                                    <span v-else><b>{{ tr.pro_nombre }}</b><br /></span>
                                </vs-td>
                                <vs-td>
                                    <div>
                                        Cantidad Solicitada: <b>{{ tr.p_libros_cantidad }}</b><br>
                                        <span v-if="tr.p_libros_cantidad_aprobada"> Cantidad Aprobada: <b>{{ tr.p_libros_cantidad_aprobada }}</b></span> <br>
                                        <span v-if="tr.p_libros_cantidad_pendiente"> Cantidad Pendiente: <b>{{ tr.p_libros_cantidad_pendiente }}</b></span> <br>
                                        <span v-if="tr.p_libros_cantidad_pendiente == 0"> <b style="color: #5cb85c;">Sin Cantidad pendiente</b></span>
                                        <vs-input v-if="tr.p_libros_cantidad_pendiente > getStockDepositoValue(tr)  && permitirStock" label="Cantidad Aprobada:" class="w-full" v-model.number="valorDespacho[index]" type="number" min="0" :change="validarCantidadAprobada(tr, index)" />
                                    </div>
                                </vs-td>
                                <vs-td>
                                    {{ getStockDepositoValue(tr)  }}
                                    <b class="ml-3" v-if="(tr.p_libros_cantidad_pendiente > getStockDepositoValue(tr)  )"> Stock insuficiente</b>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </vs-col>
            </vs-row>
            <br><br>
            <div v-if="acta.empresa">
                <vs-row>
                    <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                        <vs-textarea label="Observación:" placeholder="Escribe..." class="w-full" v-model="acta.observacion" />
                    </vs-col>
                </vs-row>
                <br><br>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" class="mt-2">
                    <vs-button @click="guardarActa();" type="relief" color="success">Guardar</vs-button>&emsp;
                    <vs-button @click="popupActa=false; permitirStock=false" color="danger" type="relief">Cancelar</vs-button>
                </vs-col>
            </div>
        </vs-popup>
        <vs-popup fullscreen :title="`Cambio del Pedido Libros Hijos Docentes n° ${librosObsequios.id}`" :active.sync="popupDetallesActa" class="popopPadre">
            <div v-if="popupDetallesActa">
                <screenModificacionPedido v-if="popupDetallesActa" :librosObsequios="librosObsequios" class="mt-2" :sendPedido="sendPedido" :userRoot="Boolean(userRoot)" />
            </div>
        </vs-popup>
        <vs-popup class="holamundo" title="Confirmacion Preaprobacion" :active.sync="popupPreAprobacion">
            <p class="text-danger text-3xl"><b class="ml-2">Estas seguro de autorizar el pedido Libros Hijos Docentes al hacerlo se guardara, para posterior aprobacion de facturador Administrator</b></p>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" class="mt-3">
                <vs-button @click="aceptarLibrosObsequios(librosObsequios,7);" type="relief" color="danger">Preaprobar</vs-button>&emsp;
                <vs-button @click="popupPreAprobacion=false;" color="primary" type="relief">Cancelar</vs-button>
            </vs-col>
        </vs-popup>
        <vs-popup class="holamundo" title="Confirmacion Anulacion" :active.sync="popupAnulacion">
            <p class="text-danger text-2xl"><b class="ml-2">Se anulara el pedido Libros Obsequios N° {{ datosAnularLibrosObsequios.id }} Tambien se anulara los siguientes Documentos</b></p>
            <vs-table max-items="10" :data="arregloActas">
                <template slot="thead">
                    <vs-th>Acta #</vs-th>
                    <vs-th>Fecha Acta</vs-th>
                </template>
                <template slot-scope="{ data }">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td> {{ tr.ven_codigo }} </vs-td>
                        <vs-td> {{ tr.ven_fecha }} </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" class="mt-3">
                <vs-button @click="AnularLibrosObsequios(datosAnularLibrosObsequios,1);" type="relief" color="danger">Confirmar</vs-button>&emsp;
                <vs-button @click="popupAnulacion=false;" color="primary" type="relief">Cancelar</vs-button>
            </vs-col>
        </vs-popup>
    </vx-card>
    </template>
    
        
    <script>
    import {
        mapState
    } from "vuex";
    import vSelect from 'vue-select';
    const resumenLibrosObsequiosVue = () => import('./resumenLibrosObsequios.vue')
    const detalleAprobadorLibrosObsequios = () => import('./detalleAprobadorLibrosObsequios.vue')
    const screenPedidoLibrosObsequiosVue = () => import('./screenPedidoLibrosObsequios.vue')
    const screenModificacionPedido = () => import('./screenModificacionPedido.vue')
    const exportLibrosObsequiosVueVue = () => import('./components/exportLibrosObsequios.vue')
    const exportDetalleLibrosObsequios = () => import('./components/exportDetalleLibrosObsequios.vue')
    const actasLibrosObsequios = () => import('./components/ActasLibrosObsequios.vue')
    import PedidosRepository from "../../../../../repositories/PedidosRepository";
    export default {
        components: {
            resumenLibrosObsequiosVue,
            screenPedidoLibrosObsequiosVue,
            exportLibrosObsequiosVueVue,
            exportDetalleLibrosObsequios,
            detalleAprobadorLibrosObsequios,
            actasLibrosObsequios,
            screenModificacionPedido,
            'v-select': vSelect,
        },
        data() {
            return {
                usuario: [],
                arregloOtherUsers: [],
                arregloLibrosObsequios: [],
                arregloLibros: [],
                arregloActas: [],
                datosAnularLibrosObsequios: [],
                datosActa: {},
                listaEmpresas: [],
                librosObsequios: {},
                DatosAprobar: {},
                pedido: {},
                pedidoLibrosObsequios: {
                    observacion_asesor: '',
                },
                selectedOption: '',
                acta: {
                    codigoPedidoLibrosActa: '',
                    id_pedido_librosObsequios: '',
                    empresa: '',
                    institucion: '',
                    responsable: '',
                    ci: '',
                    direccion: '',
                    telefono: '',
                    observacion: '',
                    descuento: '',
                    descuentoInstitucion: '',
                    beneficiario: '',
                },
                menu: 0,
                popupCarga: false,
                popupReportePedidoLibroObsequio: false,
                popupDetallePedidoLibroObsequio: false,
                popupPreAprobacion: false,
                popupAnulacion: false,
                tipoFile: 0,
                sendPedido: '',
                seleccion: '',
                idDato: 0,
                institucion: '',
                institucion: '',
                observacion_detalle: '',
                porcentaje_detalle: '',
                popupActa: false,
                exportTodo: false,
                codigoActa: [],
                popupDatosDetalle: false,
                mostrarMensajeEnviado: false,
                itemsDelPedido: 0,
                valorDespacho: [],
                permitirStock: false,
                datosAprobados: false,
                arregloBeneficiario: [],
                stockMinimoNotas: '',
                porcentaje_descuento: '',
                estadoPedidoLibrosHijosDocentes: '',
                estadoP: '',
                datoidAprobador: '',
                datonombreAprobador: '',
                validacionObsequio: false,
                isDifferent: false,
                mostrarMensajeVariacion: false,
                editActaPedido: [],
                popupDetallesActa: false,
                mostrardatosDetalles: false,
            }
        },
        computed: {
            ...mapState(["auth", 'userRoot', 'susuario', 'ObjectPedido', 'groupFacturador', 'userAsesor']),
        },
        created() {
            let me = this
            me.usuario = JSON.parse(localStorage.getItem("usuario"))
            // this.$on('guardar-informacion', () => {
            //     this.mostrarMensaje = true;
            // });
        },
        mounted() {
            let me = this;
            me.sendPedido = me.ObjectPedido
            me.pedido.id_pedido = me.sendPedido.id_pedido
            me.getProductosStockMinimoNotas()
            if (me.usuario.id_group == 22 || me.usuario.id_group == 23) {
                me.getLibrosObsequios(6)
                me.seleccion = 'gerencia1'
            } else {
                me.getLibrosObsequios(0)
            }
            this.mostrarMensajeEnviado = false;
        },
        methods: {
            evaluarCedulaCliente() {
                let me = this;
                const rucCliente = this.acta.ci;
                if (rucCliente.length > 0) {
                    if (me.arregloOtherUsers.length > 0) {
                        this.isDifferent = !this.arregloOtherUsers.some(usuario => usuario.ruc_cliente === rucCliente);
                        if (this.isDifferent) {
                            this.mostrarMensajeVariacion = true;
                            console.log("El CI es diferente a los ruc_cliente en arregloUsuario.");
                        } else {
                            this.mostrarMensajeVariacion = false;
                            console.log("El CI es igual a uno de los ruc_cliente en arregloUsuario.");
                        }
                    }
                }
            },
            abrirModificacionPedidoActa(tr) {
                let me = this;
                setTimeout(() => {
                    me.popupDetallesActa = true;
                }, 100);
            },
            abrirAnularLibrosObsequios(tr, estado) {
                let me = this;
                me.datosAnularLibrosObsequios = tr;
                me.getLibros(tr.id)
                me.popupAnulacion = true;
    
            },
            getLibros(dato) {
                this.$vs.loading();
                this.$http
                    .get(this.$server_url + "obtenerDocumentosLibrosObsequios/" + dato)
                    .then((res) => {
                        this.arregloActas = res.data;
                        this.$vs.loading.close();
                    })
                    .catch((error) => {
                        console.error(error);
                        this.$vs.loading.close();
                    });
            },
            AnularLibrosObsequios(tr, estado) {
                let me = this;
                let formData = new FormData();
                formData.append('id', tr.id);
                formData.append('estado_libros_obsequios', estado);
                me.$vs.loading();
                this.$http.post(this.$server_url + 'AnularLibrosObsequios', formData)
                    .then(function (res) {
                        me.$vs.loading.close()
                        if (res.data.status == 0) {
                            me.$vs.notify({
                                text: res.data.message,
                                color: 'warning',
                                iconPack: 'feather',
                                icon: 'icon-alert-triangle'
                            })
                            return
                        }
                        me.getLibrosObsequios(0)
                        me.menu = 0
                        me.popupAnulacion = false;
                        me.$vs.notify({
                            text: res.data.message,
                            color: 'primary',
                            iconPack: 'feather',
                            icon: 'icon-alert-triangle'
                        })
                    })
                    .catch(function (error) {
                        me.$vs.loading.close()
                    })
            },
            ponerCedulaCliente() {
                // Encuentra el beneficiario seleccionado
                const seleccionado = this.arregloBeneficiario.find(beneficiario => beneficiario.id_usuario == this.acta.beneficiario);
    
                if (seleccionado) {
                    // Si hay un beneficiario seleccionado, asigna su cédula
                    this.acta.ci = seleccionado.cedula;
                } else {
                    // Si no hay beneficiario seleccionado, limpia el campo de cédula
                    this.acta.ci = '';
                }
            },
            getStockDepositoValue(tr) {
                if (this.acta.empresa === 1) {
                    return tr.pro_deposito;
                } else if (this.acta.empresa === 3) {
                    return tr.pro_depositoCalmed; // Cambia a tr.pro_depositoCalmed cuando acta.empresa es 3
                } else {
                    return 0; // Valor por defecto
                }
            },
            getProductosStockMinimoNotas() {
                let me = this;
                me.$vs.loading();
                this.$http.get(this.$server_url + 'getProductosStockMinimoNotas')
                    .then(function (res) {
                        me.stockMinimoNotas = res.data[0].minimo
                        console.log(me.stockMinimoNotas, 'minimo')
                        me.$vs.loading.close()
                    })
                    .catch(function (error) {
                        me.$vs.loading.close()
                    })
            },
            validarCantidadAprobada(tr, index) {
                if (this.valorDespacho[index] < 0) {
                    this.valorDespacho[index] = 0;
                } else if (this.valorDespacho[index] > tr.pro_deposito) {
                    this.valorDespacho[index] = tr.pro_deposito;
                }
            },
            vacilarEmits() {
                this.itemsDelPedido = 0;
                this.estadoPedidoLibrosHijosDocentes = '';
                this.validacionObsequio = false;
            },
            recibirCantidad(cantidad, estado, obsequio) {
                this.vacilarEmits();
                if (cantidad) {
                    this.itemsDelPedido = cantidad;
                    if (cantidad > 0) {
                        this.mostrarMensajeEnviado = true;
                    }
                }
                if (estado) {
                    this.estadoPedidoLibrosHijosDocentes = estado;
                }
                if (obsequio) {
                    this.validacionObsequio = obsequio;
                }
                console.log("Cantidad de libros recibidos:", cantidad, 'con el estado de', estado, 'es obsequio:', obsequio);
    
            },
            getLibrosObsequios(tipo) {
                let me = this;
                if (tipo == 0) {
                    me.exportTodo = false;
                    me.mostrarMensajeEnviado = false;
                }
                me.$vs.loading();
                this.$http.get(this.$server_url + 'getLibrosObsequios?id_pedido=' + me.pedido.id_pedido + '&usuario=' + me.usuario.id_group)
                    .then(function (res) {
                        me.$vs.loading.close()
                        me.arregloLibrosObsequios = res.data
                        if (me.usuario.id_group == 22) {
                            let datos = res.data.filter(p => (p.estado_libros_obsequios == 0 || (p.estado_libros_obsequios == 3 && p.porcentaje_descuento < 100) || p.estado_libros_obsequios == 4 || p.estado_libros_obsequios == 5 || p.estado_libros_obsequios == 6 || p.estado_libros_obsequios == 7 || p.estado_libros_obsequios == 2 || p.estado_libros_obsequios == 8))
                            me.arregloLibrosObsequios = datos
                        }
                        if (tipo == 1) {
                            let datos = res.data.filter(p => p.estado_libros_obsequios == 0)
                            me.librosObsequios = datos[0]
                            me.menu = 3
                            me.exportTodo = false
                            me.mostrarMensajeEnviado = false;
                        }
                        // if (tipo == 5) {
                        //     let datos = res.data.filter(p => p.estado_libros_obsequios == 4)
                        //     me.arregloLibrosObsequios = datos
                        //     me.exportTodo=false
                        //     me.mostrarMensajeEnviado = false;
                        // }
                        if (tipo == 6) {
                            let datos;
                            if (me.usuario.id_group == 23 || me.usuario.id_group == 1 || me.usuario.id_group == 0) {
                                datos = res.data.filter(p => (p.estado_libros_obsequios == 7 || p.estado_libros_obsequios == 0 || p.estado_libros_obsequios == 3 || p.estado_libros_obsequios == 4 || p.estado_libros_obsequios == 6 || p.estado_libros_obsequios == 8))
                            } else if (me.usuario.id_group == 22) {
                                datos = res.data.filter(p => (p.estado_libros_obsequios == 0 || (p.estado_libros_obsequios == 3 && p.porcentaje_descuento < 100) || p.estado_libros_obsequios == 4 || p.estado_libros_obsequios == 6 || p.estado_libros_obsequios == 8))
                            }
                            me.arregloLibrosObsequios = datos
                            me.exportTodo = false
                            me.mostrarMensajeEnviado = false;
                        }
                        if (tipo == 7) {
                            let datos = res.data.filter(p => p.estado_libros_obsequios == 5)
                            me.arregloLibrosObsequios = datos
                            me.exportTodo = true
                            me.mostrarMensajeEnviado = false;
                            console.log(me.arregloLibrosObsequios.length)
                            if (me.arregloLibrosObsequios.length > 0) {
                                me.datosAprobados = me.arregloLibrosObsequios.length;
                            }
                        }
                        if (tipo == 8) {
                            let datos = res.data.filter(p => p.estado_libros_obsequios == 2)
                            me.arregloLibrosObsequios = datos
                            me.exportTodo = false
                            me.mostrarMensajeEnviado = false;
                        }
                    })
                    .catch(function (error) {
                        console.log(error + ' error');
                        me.$vs.loading.close()
                    })
            },
            mostrarResumen(tr) {
                let me = this;
                me.menu = 2
            },
            mostrarDetalle(tr) {
                let me = this;
                me.menu = 5
            },
            eliminarLibrosObsequios() {
                let me = this;
                let formData = new FormData();
                formData.append('id', me.librosObsequios.id);
                formData.append('id_pedido', me.pedido.id_pedido);
                me.$vs.loading();
                this.$http.post(this.$server_url + 'eliminarPedidoLibrosObsequios', formData)
                    .then(function (res) {
                        me.$vs.loading.close()
                        me.$vs.notify({
                            text: 'Se elimino correctamente el pedido libros obsequips',
                            color: 'primary',
                            iconPack: 'feather',
                            icon: 'icon-alert-triangle'
                        })
                        me.getLibrosObsequios(0)
                        me.menu = 0
                    })
                    .catch(function (error) {
                        me.$vs.loading.close()
                    })
            },
            async guardarValorPedidoLibrosObsequios() {
                let me = this
                const usuariorespo = localStorage.getItem("usuario");
                const usuarioObjeto = JSON.parse(usuariorespo);
                let formData = new FormData();
                formData.append('id', 0)
                formData.append('user_created', usuarioObjeto.idusuario);
                formData.append('id_periodo', me.sendPedido.id_periodo);
                formData.append('id_pedido', me.pedido.id_pedido);
                formData.append('total_unidades', 0);
                this.$http.post(this.$server_url + 'guardarValorPedidoLibrosObsequios', formData)
                    .then(function (res) {
                        if (res.data.status == 0) {
                            me.$vs.notify({
                                text: res.data.message,
                                color: 'warning',
                                iconPack: 'feather',
                                icon: 'icon-alert-triangle',
                                time: 7000,
                            })
                            return
                        }
                        me.$vs.notify({
                            text: 'Se guardo correctamente',
                            color: 'primary',
                            iconPack: 'feather',
                            icon: 'icon-alert-triangle'
                        })
                        me.getLibrosObsequios(1)
                    })
                    .catch(function (error) {})
            },
            VerificacionRechazoPedido(tr) {
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: `Confirmar rechazo `,
                    acceptText: 'Si, deseo rechazar el pedido Libros Hijos Docentes.',
                    cancelText: 'Cancelar',
                    text: 'Estás seguro de rechazar el pedido Libros Hijos Docentes.',
                    accept: () => this.CambiarEstadoPedidoLibrosObsequios(tr, 2) // Cambio aquí
                })
            },
            CambiarEstadoPedidoLibrosObsequios(tr, estado) {
                let me = this;
                let formData = new FormData();
                formData.append('id', tr.id);
                formData.append('estado_libros_obsequios', estado);
                me.$vs.loading();
                this.$http.post(this.$server_url + 'changeEstadoPedidoLibrosObsequios', formData)
                    .then(function (res) {
                        me.$vs.loading.close()
                        if (res.data.status == 0) {
                            me.$vs.notify({
                                text: res.data.message,
                                color: 'warning',
                                iconPack: 'feather',
                                icon: 'icon-alert-triangle'
                            })
                            return
                        }
                        me.$vs.notify({
                            text: res.data.message,
                            color: 'primary',
                            iconPack: 'feather',
                            icon: 'icon-alert-triangle'
                        })
                        me.getLibrosObsequios(0)
                    })
                    .catch(function (error) {
                        me.$vs.loading.close()
                    })
            },
            CambiarEstadoLibrosObsequios(tr, estado) {
                let me = this;
                if (me.usuario.id_group == 11) {
                    if (!this.pedidoLibrosObsequios.observacion_asesor) {
                        this.$vs.notify({
                            text: 'Escriba la observación antes de enviar.',
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-triangle'
                        });
                        return;
                    }
                }
                if (me.itemsDelPedido <= 0) {
                    this.$vs.notify({
                        text: 'No tiene items para guardar.',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-triangle'
                    });
                    return;
                }
                let formData = new FormData();
                formData.append('id', tr.id);
                formData.append('estado_libros_obsequios', estado);
                formData.append('obsequio', me.validacionObsequio);
                if (me.usuario.id_group == 11) {
                    formData.append('observacion_asesor', me.pedidoLibrosObsequios.observacion_asesor);
                } else {
                    formData.append('observacion_asesor', 'No creado por un Asesor');
                }
                me.$vs.loading();
                this.$http.post(this.$server_url + 'CambiarEstadoLibrosObsequios', formData)
                    .then(function (res) {
                        me.$vs.loading.close()
                        if (res.data.status == 0) {
                            me.$vs.notify({
                                text: res.data.message,
                                color: 'warning',
                                iconPack: 'feather',
                                icon: 'icon-alert-triangle'
                            })
                            return
                        }
                        me.getLibrosObsequios(0)
                        me.menu = 0
                        me.pedidoLibrosObsequios.observacion_asesor = ''
                        me.$vs.notify({
                            text: res.data.message,
                            color: 'primary',
                            iconPack: 'feather',
                            icon: 'icon-alert-triangle'
                        })
                    })
                    .catch(function (error) {
                        me.$vs.loading.close()
                    })
            },
            openConfirmLibrosObsequios() {
                let me = this;
                me.popupPreAprobacion = true;
    
            },
            aceptarLibrosObsequios(tr, estado) {
                let me = this;
                let formData = new FormData();
                formData.append('id', tr.id);
                formData.append('estado_libros_obsequios', estado);
                formData.append('observacion_asesor', me.pedidoLibrosObsequios.observacion_asesor);
                formData.append('user_created_name', me.usuario.nombres + ' ' + me.usuario.apellidos);
                formData.append('user_created', me.usuario.idusuario);
                me.$vs.loading();
                this.$http.post(this.$server_url + 'AceptarLibrosObsequiosFacturador', formData)
                    .then(function (res) {
                        me.$vs.loading.close()
                        if (res.data.status == 0) {
                            me.popupPreAprobacion = true;
                            me.$vs.notify({
                                text: res.data.message,
                                color: 'warning',
                                iconPack: 'feather',
                                icon: 'icon-alert-triangle'
                            })
                            return
    
                        } else {
                            me.$vs.notify({
                                text: 'Se guardo correctamente',
                                color: 'primary',
                                iconPack: 'feather',
                                icon: 'icon-alert-triangle'
                            })
                            me.getLibrosObsequios(0)
                            me.rechargePedido()
                            me.popupPreAprobacion = false;
                        }
                    })
                    .catch(function (error) {
                        me.$vs.loading.close()
                    })
            },
            rechargePedido() {
                let me = this
                PedidosRepository.getPedidoXID(me.sendPedido.id_pedido).then(r => {
                    this.$store.dispatch('setPedido', r.data[0]);
                })
            },
            actasLibrosObsequios() {
                let me = this;
                me.menu = 6;
            },
            realizarReporte(tipo) {
                let me = this;
                me.tipoFile = tipo
                me.popupCarga = true
                me.popupReportePedidoLibroObsequio = true
            },
            AbrirDatosDetalle() {
                let me = this;
                me.porcentaje_detalle = ''
                me.observacion_detalle = ''
                me.popupDatosDetalle = true
            },
            guardarDatosDetalle() {
                let me = this;
                me.realizarDetalle(1)
                me.popupDatosDetalle = false
                // let formData = new FormData();
                // formData.append('id_pedidoLibrosObsequios', me.datosActa.id);
                // formData.append('contrato', me.librosObsequios.contrato_generado);
                // this.$http.post(this.$server_url + 'AceptarLibrosObsequios', formData)
                // .then(function (res) {
                //         me.$vs.loading.close()
                //         if (res.data.status == 0) {
                //             me.$vs.notify({
                //                 text: res.data.message,
                //                 color: 'warning',
                //                 iconPack: 'feather',
                //                 icon: 'icon-alert-triangle'
                //             })
                //             return
                //         }
                //         me.$vs.notify({
                //             text: 'Se guardo correctamente',
                //             color: 'primary',
                //             iconPack: 'feather',
                //             icon: 'icon-alert-triangle'
                //         })
                //         me.popupDatosDetalle = false
                //         me.realizarDetalle(1)
                //     })
                //     .catch(function (error) { me.$vs.loading.close() })
    
            },
            realizarDetalle(tipo) {
                let me = this;
                me.tipoFile = tipo
                me.popupCarga = true
                me.popupDetallePedidoLibroObsequio = true
            },
            changeHandle(e) {
                let me = this;
                me.popupCarga = false
                me.popupReportePedidoLibroObsequio = false
                me.popupDetallePedidoLibroObsequio = false
            },
            getEmpresas() {
                let me = this;
                me.$vs.loading();
                this.$http.get(this.$server_url + 'empresa')
                    .then(res => {
                        me.listaEmpresas = res.data.filter(empresa => empresa.id != 2);
                        me.$vs.loading.close();
                    })
                    .catch(err => {
                        console.error(err);
                        me.$vs.loading.close();
                    });
            },
            getLibrosObsequiosActa(id) {
                let me = this;
                let id_pedido_obsequio = id;
                me.$vs.loading();
                this.$http.get(this.$server_url + 'getLibrosObsequiosActa?id_pedido_obsequio=' + id_pedido_obsequio)
                    .then(res => {
                        me.datosActa = res.data;
                        me.acta.institucion = me.datosActa[0].nombreInstitucion;
                        me.acta.id_pedido_librosObsequios = me.datosActa[0].id;
                        me.acta.responsable = me.datosActa[0].asesor;
                        me.acta.estado_libros_obsequios = me.datosActa[0].estado_libros_obsequios;
                        me.acta.ci = '';
                        // me.acta.ci = me.datosActa[0].cedulaAsesor;
                        me.acta.direccion = me.datosActa[0].direccionInstitucion;
                        me.acta.telefono = me.datosActa[0].telefonoInstitucion;
                        me.tipo_venta = me.datosActa[0].tipo_venta;
                        me.institucion = me.datosActa[0].institucion;
                        me.acta.descuentoInstitucion = me.datosActa[0].porcentaje;
                        me.acta.descuento = 100;
                        me.getOtherUsers(me.institucion);
                        me.$vs.loading.close();
                    })
                    .catch(err => {
                        console.error(err);
                        me.$vs.loading.close();
                    });
            },
            getLibrosActa(idPedidoObsequio) {
                let me = this;
                me.arregloLibros = [];
                // this.$http.get(this.$server_url+'get_val_pedidoInfo_librosObsequios/'+idPedido+'/'+idPedidoObsequio)
                this.$http.get(this.$server_url + 'obtenerDatosDetalleLibros/' + idPedidoObsequio)
                    .then(res => {
                        let datos = res.data;
                        me.arregloLibros = datos;
    
                        me.arregloLibros.forEach((tr, index) => {
                            this.$set(this.valorDespacho, index, tr.pro_deposito);
                        });
    
                        // Verificar si hay cantidades pendientes
                        let pendiente = false;
                        for (let item of me.arregloLibros) {
                            if (item.p_libros_cantidad_pendiente !== 0) {
                                pendiente = true;
                                break;
                            }
                        }
    
                        // Si no hay cantidades pendientes, mostrar el mensaje y cerrar el popup
                        if (!pendiente) {
                            me.popupActa = false;
                            me.$vs.notify({
                                text: 'No hay cantidades pendientes',
                                color: 'primary',
                                iconPack: 'feather',
                                icon: 'icon-alert-triangle'
                            });
                        }
                    })
            },
            getCodigoActa(idempresa) {
                let me = this
                me.acta.codigoPedidoLibrosActa = '';
                // console.log('empresa:',idempresa)
                let letra, secuencia, nombrePeriodo, empresa;
                const usuariorespo = localStorage.getItem("usuario");
                const usuarioObjeto = JSON.parse(usuariorespo);
                const iniciales = usuarioObjeto.iniciales
                const primeraLetraNombre = usuarioObjeto.nombres.charAt(0);
                const primeraLetraApellido = usuarioObjeto.apellidos.charAt(0);
                const periodoPedido = me.sendPedido.codigo_contrato;
                this.$vs.loading();
                this.$http.get(this.$server_url + 'getCodigoActa?descuento=' + me.porcentaje_descuento + '&empresa=' + idempresa)
                    .then(res => {
                        me.codigoActa = res.data
                        letra = me.codigoActa[0]
                        if (idempresa == 1) {
                            empresa = 'P'
                        } else if (idempresa == 3) {
                            empresa = 'C'
                        }
                        secuencia = me.codigoActa[1]
                        me.idDato = me.codigoActa[2]
                        nombrePeriodo = periodoPedido
                        me.acta.codigoPedidoLibrosActa = letra + '-' + empresa + '-' + nombrePeriodo + '-' + iniciales + '-' + secuencia
                        this.$vs.loading.close();
                    })
                    .catch(function (error) {
                        console.log(error + ' error');
                        me.popupActa = false;
                        me.$vs.notify({
                            text: 'Error con el codigo de acta.',
                            color: 'warning',
                            iconPack: 'feather',
                            icon: 'icon-alert-triangle'
                        });
                        me.$vs.loading.close()
                    })
            },
            verificarIniciales(tr) {
                const usuariorespo = localStorage.getItem("usuario");
                const usuarioObjeto = JSON.parse(usuariorespo);
                if (!usuarioObjeto.iniciales) {
                    this.$vs.dialog({
                        type: 'confirm',
                        color: 'danger',
                        title: `Error`,
                        // acceptText: 'Aceptar',
                        cancelText: 'Cancelar',
                        text: 'Usuario sin iniciales, no puede generar ACTA. Comuniquese con el equipo de soporte.',
                        // accept: this.aceptarLibrosObsequios
                    })
                    return
                } else {
                    if (this.sendPedido.contrato_generado == null) {
                        this.$vs.dialog({
                            type: 'confirm',
                            color: 'danger',
                            title: "Alerta",
                            acceptText: 'Aceptar',
                            cancelText: 'Cancelar',
                            text: 'No se puede aceptar, el pedido general no cuenta con un contrato.',
                            // accept: this.aceptarLibrosObsequios
                        })
                        return
                    } else {
                        this.abrirguardarActa(tr)
                    }
                }
            },
            abrirguardarActa(tr) {
                let me = this;
                let idPedido = tr.id_pedido
                let idPedidoObsequio = tr.id
                me.porcentaje_descuento = tr.porcentaje_descuento
                me.popupActa = true
                me.permitirStock = false
                me.valorDespacho = []
                me.getLibrosObsequiosActa(tr.id)
                // me.getCodigoActa(me.porcentaje_descuento)
                // me.getLibrosActa(idPedidoObsequio)
                me.getEmpresas()
                me.getbeneficiario(idPedido);
                this.acta.empresa = ''
                this.acta.beneficiario = ''
                this.acta.observacion = ''
                this.estadoP = tr.estado_libros_obsequios
                this.datoidAprobador = tr.usuario_aprobacion_id
                this.datonombreAprobador = tr.usuario_aprobacion
                console.log(this.estadoP)
            },
            getOtherUsers(institucion) {
                let me = this
                this.$vs.loading();
                this.$http.get(this.$server_url + 'get_usuarios_institucion?institucion=' + institucion)
                    .then(res => {
                        let datos = res.data
                        if (datos.length > 0) {
                            me.arregloOtherUsers = datos;
                        } else {
                            me.arregloOtherUsers = [];
                        }
                        this.$vs.loading.close();
    
                        this.combinarBeneficiariosConOtrosUsuarios();
    
                    })
                    .catch(function (error) {
                        console.log(error + 'error');
                        me.$vs.loading.close()
                    })
            },
    
            // Función que combina los beneficiarios con los otros usuarios
            combinarBeneficiariosConOtrosUsuarios() {
                this.arregloBeneficiario.forEach(beneficiario => {
                    // Buscamos si hay un usuario correspondiente en arregloOtherUsers
                    let otherUser = this.arregloOtherUsers.find(user => user.ven_cliente.toString() === beneficiario.id_usuario.toString());
    
                    if (otherUser) {
                        // Si encontramos un usuario correspondiente, actualizamos los datos en el beneficiario
                        beneficiario.cedula = otherUser.ruc_cliente; // Actualizamos la cédula con el RUC
                        beneficiario.fullLabel = `${otherUser.nombre} (${otherUser.ruc_cliente})`; // Actualizamos el fullLabel con el nombre y RUC
                    }
                });
    
                // Ahora agregamos los usuarios de arregloOtherUsers que no han sido combinados
                this.arregloOtherUsers.forEach(user => {
                    // Verificamos si el ven_cliente no existe en arregloBeneficiario
                    let matchingBeneficiario = this.arregloBeneficiario.find(beneficiario => beneficiario.id_usuario.toString() === user.ven_cliente.toString());
    
                    if (!matchingBeneficiario) {
                        // Si no hay coincidencia, los agregamos a arregloBeneficiario
                        this.arregloBeneficiario.push({
                            id_usuario: user.ven_cliente, // id_usuario es igual a ven_cliente
                            cedula: user.ruc_cliente, // Cedula será igual al ruc_cliente
                            fullLabel: `${user.nombre} (${user.ruc_cliente})`, // fullLabel es nombre + ruc_cliente
                        });
                    }
                });
    
                console.log(this.arregloBeneficiario); // Para verificar los datos combinados y añadidos
            },
    
            getbeneficiario(idPedido) {
                let me = this
                this.$vs.loading();
                this.$http.get(this.$server_url + 'get_beneficiarios_pedidos/' + idPedido)
                    .then(res => {
                        let datos = res.data
                        me.arregloBeneficiario = datos
                        this.arregloBeneficiario.map(beneficiario => {
                            beneficiario.fullLabel = `${beneficiario.nombres_beneficiario} (${beneficiario.cedula})`; // Concatenamos el nombre con la cédula
                        });
                        this.$vs.loading.close();
                    })
                    .catch(function (error) {
                        console.log(error + ' error');
                        me.$vs.loading.close()
                    })
            },
            guardarActa() {
                let me = this;
                const usuariorespo = localStorage.getItem("usuario");
                const usuarioObjeto = JSON.parse(usuariorespo);
                if (!me.acta.empresa) {
                    me.$vs.notify({
                        text: 'Falta la selección de Empresa.',
                        color: 'warning',
                        iconPack: 'feather',
                        icon: 'icon-alert-triangle'
                    });
                    return;
                }
    
                if (!me.acta.beneficiario) {
                    console.log(me.acta.beneficiario, 'xd');
                    me.$vs.notify({
                        text: 'Falta el cliente.',
                        color: 'warning',
                        iconPack: 'feather',
                        icon: 'icon-alert-triangle'
                    });
                    return;
                }
                if (!me.acta.ci) {
                    console.log(me.acta.ci, 'xd');
                    me.$vs.notify({
                        text: 'Falta el cedula cliente.',
                        color: 'warning',
                        iconPack: 'feather',
                        icon: 'icon-alert-triangle'
                    });
                    return;
                }
    
                let valor_total_aprobacion = 0;
                let valor_Descuento = 0
                console.log(me.porcentaje_descuento)
                let nuevoArregloLibros = me.arregloLibros.map((libro, index) => {
                    if (me.porcentaje_descuento == 100) {
                        valor_total_aprobacion += libro.p_libros_valor_u * libro.p_libros_cantidad;
                        valor_Descuento = parseFloat((valor_total_aprobacion * me.porcentaje_descuento) / 100).toFixed(2);
                    } else {
                        valor_total_aprobacion += libro.p_libros_valor_u * libro.p_libros_cantidad;
                        valor_Descuento = parseFloat((valor_total_aprobacion * me.porcentaje_descuento) / 100).toFixed(2);
                    }
    
                    let cantidad_aprobada = me.permitirStock && libro.p_libros_cantidad_pendiente > libro.pro_deposito ? me.valorDespacho[index] : libro.p_libros_cantidad_pendiente;
    
                    let cantidadPendiente = libro.p_libros_cantidad_pendiente - cantidad_aprobada;
                    if (cantidadPendiente < 0) {
                        cantidadPendiente = 0;
                    }
    
                    return {
                        ...libro,
                        p_libros_cantidad_aprobada: cantidad_aprobada,
                        p_libros_cantidad_pendiente: cantidadPendiente
                    };
                });
    
                console.log('valor_total_aprobacion:', valor_total_aprobacion);
                console.log('valor_Descuento:', valor_Descuento);
                console.log('valor nulo', nuevoArregloLibros)
    
                if (me.acta.empresa == 1) {
                    if (me.permitirStock) {
                        if (nuevoArregloLibros.some(libro => libro.p_libros_cantidad_aprobada > libro.pro_deposito)) {
                            me.$vs.notify({
                                text: 'La cantidad de libros en el pedido supera el stock disponible.',
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-triangle'
                            });
                            return;
                        } else if (nuevoArregloLibros.some(valor => valor.p_libros_cantidad_aprobada === undefined || valor.p_libros_cantidad_aprobada === null || valor.p_libros_cantidad_aprobada === '')) {
                            me.$vs.notify({
                                text: 'Error en la cantidad a despachar.',
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-triangle'
                            });
                            return;
                        } else if (!nuevoArregloLibros.some(valor => parseFloat(valor.p_libros_cantidad_aprobada) > 0)) {
                            me.$vs.notify({
                                text: 'Debe ingresar al menos una cantidad aprobada mayor que 0.',
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-triangle'
                            });
                            return;
                        }
                    } else {
                        if (me.arregloLibros.some(libro => libro.p_libros_cantidad_pendiente > libro.pro_deposito)) {
                            me.$vs.notify({
                                text: 'La cantidad de libros en el pedido supera el stock disponible.',
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-triangle'
                            });
                            return;
                        }
                    }
                } else if (me.acta.empresa == 3) {
                    if (me.permitirStock) {
                        if (nuevoArregloLibros.some(libro => libro.p_libros_cantidad_aprobada > libro.pro_depositoCalmed)) {
                            me.$vs.notify({
                                text: 'La cantidad de libros en el pedido supera el stock disponible.',
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-triangle'
                            });
                            return;
                        } else if (nuevoArregloLibros.some(valor => valor.p_libros_cantidad_aprobada === undefined || valor.p_libros_cantidad_aprobada === null || valor.p_libros_cantidad_aprobada === '')) {
                            me.$vs.notify({
                                text: 'Error en la cantidad a despachar.',
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-triangle'
                            });
                            return;
                        } else if (!nuevoArregloLibros.some(valor => parseFloat(valor.p_libros_cantidad_aprobada) > 0)) {
                            me.$vs.notify({
                                text: 'Debe ingresar al menos una cantidad aprobada mayor que 0.',
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-triangle'
                            });
                            return;
                        }
                    } else {
                        if (me.arregloLibros.some(libro => libro.p_libros_cantidad_pendiente > libro.pro_depositoCalmed)) {
                            me.$vs.notify({
                                text: 'La cantidad de libros en el pedido supera el stock disponible.',
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-triangle'
                            });
                            return;
                        }
                    }
                }
    
                if (!me.acta.observacion) {
                    me.$vs.notify({
                        text: 'Falta la observación.',
                        color: 'warning',
                        iconPack: 'feather',
                        icon: 'icon-alert-triangle'
                    });
                    return;
                }
                if (!me.acta.codigoPedidoLibrosActa) {
                    me.$vs.notify({
                        text: 'Error codigo de documento.',
                        color: 'warning',
                        iconPack: 'feather',
                        icon: 'icon-alert-triangle'
                    });
                    return;
                }
                let formData = new FormData();
                formData.append("ven_codigo", me.acta.codigoPedidoLibrosActa);
                formData.append("tip_ven_codigo", me.tipo_venta);
                formData.append("ven_observacion", me.acta.observacion);
                formData.append("id_empresa", me.acta.empresa);
                formData.append('periodo_id', me.sendPedido.id_periodo);
                formData.append('institucion_id', me.institucion);
                formData.append('user_created', me.usuario.idusuario);
                formData.append('id_dato', me.codigoActa[2]);
                formData.append('secuencia', me.codigoActa[1]);
                formData.append('id_pedidoLibrosObsequios', me.acta.id_pedido_librosObsequios);
                formData.append('pendiente', me.permitirStock ? 'si' : 'no');
                formData.append('cliente_beneficiario', me.acta.beneficiario);
                formData.append('valor_total', valor_total_aprobacion);
                formData.append('ven_desc_por', me.porcentaje_descuento);
                formData.append('ven_descuento', valor_Descuento);
                formData.append('ruc_cliente', me.acta.ci);
                if (me.estadoP !== 4) {
                    formData.append('usuario_aprobacion_id', usuarioObjeto.idusuario);
                    formData.append('usuario_aprobacion', usuarioObjeto.nombres + ' ' + usuarioObjeto.apellidos);
                } else {
                    formData.append('usuario_aprobacion_id', me.datoidAprobador);
                    formData.append('usuario_aprobacion', me.datonombreAprobador);
                }
                formData.append("datos_detalle_venta", JSON.stringify(nuevoArregloLibros));
    
                this.$http.post(this.$server_url + 'Acta_LibrosObsequios_Registrar_modificar', formData)
                    .then(function (res) {
                        me.$vs.loading.close()
                        if (res.data.status == 0) {
                            me.$vs.notify({
                                text: res.data.message,
                                color: 'warning',
                                iconPack: 'feather',
                                icon: 'icon-alert-triangle'
                            })
                        } else {
                            me.$vs.notify({
                                text: 'Se guardó correctamente',
                                color: 'primary',
                                iconPack: 'feather',
                                icon: 'icon-alert-triangle'
                            })
                            me.popupActa = false
                            me.porcentaje_descuento = ''
                            me.datoidAprobador = ''
                            me.datonombreAprobador = ''
                            me.getLibrosObsequios(0)
                            me.estadoP = ''
                        }
                    })
                    .catch(function (error) {
                        me.$vs.notify({
                            text: error.response.data.message, // Aquí usamos error en lugar de res
                            color: 'warning',
                            iconPack: 'feather',
                            icon: 'icon-alert-triangle'
                        })
                        me.estadoP = ''
                        me.datoidAprobador = ''
                        me.datonombreAprobador = ''
                        me.$vs.loading.close();
                    });
            },
        }
    }
    </script>
        
    <style scoped>
    .popopPadre {
        z-index: 51008;
        /* Valor mayor que el del popup del padre */
        position: fixed;
        /* Asegúrate de que la posición sea adecuada */
    }
    </style>
    